import { useEffect, useState } from "react";
import { Cookies } from "react-cookie";

import { auth } from "#/utils";
import { fixString, useLocation, useNavigate } from "@monta/router-react";

import { AUTH_ROUTE_EXCEPTIONS, PUBLIC_PAGES } from "#/routes/route";

import type { PropsWithChildren } from "react";

type Props = PropsWithChildren;

const AuthProvider = (props: Props) => {
  const { children } = props;

  const location = useLocation();
  const navigate = useNavigate();
  const { subTypeId } = auth.useAuth() ?? {};
  const [canSeePage, setCanSeePage] = useState(false);

  const isIndex = location.pathname === "/";
  const isPublicPage = PUBLIC_PAGES.includes(location.pathname);
  const isAuthPage = location.pathname.includes("/auth");
  const isProtectedPage = !isPublicPage && !isAuthPage;

  const redirectToAuthPath = `/auth?redirect=${encodeURIComponent(fixString(location.pathname === "/" ? "/dashboard" : location.pathname, "APPLICATION_URL"))}`;

  useEffect(() => {
    const accessToken = new Cookies().get("accessToken");

    if (!subTypeId && accessToken) return;

    if (
      (isAuthPage && !accessToken) ||
      (isProtectedPage && accessToken) ||
      (accessToken && AUTH_ROUTE_EXCEPTIONS.includes(location.pathname)) ||
      (location.pathname == "/auth/otp" &&
        new URLSearchParams(window.location.search).get("type") ===
          "SUBMIT_PHONE_NUMBER") ||
      location.pathname == "/exam-management/simplified/" ||
      location.pathname == "/exam-management/simplified"
    ) {
      setCanSeePage(true);
      return;
    }

    if ((isProtectedPage || isIndex) && !accessToken)
      navigate(redirectToAuthPath);
  }, [
    isAuthPage,
    isIndex,
    isProtectedPage,
    location.pathname,
    navigate,
    redirectToAuthPath,
    subTypeId
  ]);

  if (isPublicPage) return children;

  return canSeePage ? children : null;
};

export default AuthProvider;
